import type { IconSvgObject } from './types';

const FlipTopIcon: IconSvgObject = [
  ["path", { d: "M3 15L3 16M3 19C3 20.6569 4.34315 22 6 22M21 15V16M21 19C21 20.6569 19.6569 22 18 22M10 22L14 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 5C3 3.34315 4.34315 2 6 2L18 2C19.6569 2 21 3.34315 21 5V11C21 11.5523 20.5523 12 20 12L4 12C3.44772 12 3 11.5523 3 11L3 5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FlipTopIcon;
